import { render, staticRenderFns } from "./CoursesPagination.vue?vue&type=template&id=8c9989e2"
import script from "./CoursesPagination.vue?vue&type=script&lang=js"
export * from "./CoursesPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports